import Separator from "@/app/components/lib/Separator";
import { unit } from "@/api/AppApi/services/product/interfaces/api-product-details-interface";
import { useTranslation } from "@/hooks/localization/useTranslations";
import OptionsDropdown from "@/app/components/common-addons-builder/common-addons-fields/hook-dropdown/options-dropdown/OptionsDropdown";
import CheckboxOption from "@/app/components/common-filter-builder/common-filters-components/CheckboxOption";

type TProps = {
  units: unit[];
  onSelect: (unit: unit) => void;
  selectedUnitId: unit["id"];
};

const Units: React.FC<TProps> = ({ onSelect, units, selectedUnitId }) => {
  const t = useTranslation();

  if (!units.length) {
    return;
  }
  const selectedUnit = units.find(({ id }) => id === selectedUnitId);

  return (
    <>
      <Separator startLabel={t.unit} marginBottom={-20} />
      <OptionsDropdown title={selectedUnit?.name ?? t.choose_from_list}>
        {units?.map((uint) => (
          <CheckboxOption
            key={uint.id}
            label={uint.name}
            disabled={uint.id === selectedUnitId}
            checked={uint.id === selectedUnitId}
            toggleOption={() => onSelect(uint)}
          />
        ))}
      </OptionsDropdown>
    </>
  );
};

export default Units;
